import { BaseForm } from '@/components/form/form';
import FormField from '@/components/form/form-field';
import { IContact } from '@/modules/contact/model/contact';
import { useState } from 'react';

export function SelectContactForm(props: {
  onSelectContact: (item: IContact) => void,
  onCancel: () => void
}) {
  const [contact, setContact] = useState<IContact | null>(null);

  return (
    <BaseForm
      onCancel={props.onCancel}
      onFinish={() => {
        props.onSelectContact(contact!);
      }}
    >
      <div className="mb-8">
        <FormField
          name="contact"
          component="queryfield"
          componentProps={{
            label: 'Pilih Kontak',
            endpoint: 'contacts',
            keyOptionLabel: 'contact_name',
            keyOptionValue: 'contact_id',
            keyQueryFilter: 'contact_name',
            queryFilter: { is_active: true },
            onSelected(item: any) {
              setContact(item.record);
            },
          }}
        />
      </div>
    </BaseForm>
  );
}

export default SelectContactForm;
